unable to read source [project]/packages/core/src/devtools/mergeDebugSequence.ts